module.exports = __webpack_public_path__ + "static/media/dms-man02.a2ced22c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dms-man02.png
// module id = 1001
// module chunks = 2